import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getOrderDataById } from '../../../../services/clinicPortalServices/orderEditService';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import {
    saveRequisitionChanges,
    createRequisitionPDF
} from '../../../../services/clinicPortalServices/requisitionService';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import store from '../../../../redux/store';
import actions from '../../../../redux/actions';
import { bindActions } from 'redux-zero/utils';

const boundActions = bindActions(actions, store);

export default class UpgradePanelPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderDetails: null,
            targetPanelId: '',
            panelTests: [],
            allTests: []
        };
    }

    componentDidMount() {
        if (
            this.props.data.facility_id.testIds &&
            this.props.data.facility_id.testIds.length &&
            this.props.data.facility_id.testIds.filter((item) => item.is_panel) &&
            this.props.data.facility_id.testIds.filter((item) => item.is_panel).length
        ) {
            this.setState({
                panelTests: this.props.data.facility_id.testIds.filter((item) => item.is_panel),
                allTests: this.props.context.componentParent.state.allSingleTests,
                targetPanelId: this.props.data.facility_id.testIds.filter((item) => item.is_panel)[0]._id
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && this.props.show !== prevProps.show) {
            getOrderDataById(this.props.data._id).then((res) => {
                this.setState({ orderDetails: res.data });
            });
        }
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleUpgrade = async () => {
        boundActions.startBlockUILoading();
        let testDetails = this.state.panelTests.find((item) => item._id === this.state.targetPanelId);
        let orderIds = [];
        for (let i = 0; i < testDetails.testIds.length; i++) {
            let testId = testDetails.testIds[i];
            let subTestDetails;
            this.state.allTests.map((test) => {
                if (test._id === testId) {
                    subTestDetails = test;
                }
                return null;
            });
            let sample = this.state.orderDetails.test_info.sample;
            let reqInfo = this.getParamsForRequisition(
                this.state.orderDetails.patient_id._id,
                sample,
                subTestDetails,
                'sub_panel'
            );
            if (this.state.orderDetails.patient_insurance_id && this.state.orderDetails.patient_insurance_id._id) {
                reqInfo.patientInsuranceId = this.state.orderDetails.patient_insurance_id._id;
            }
            if (this.state.orderDetails.test_id.is_panel) {
                let originalRequisition = this.state.orderDetails.orderIds.find((item) => item.test_id === testId);
                if (originalRequisition) {
                    reqInfo._id = originalRequisition._id;
                }
                reqInfo.parent_id = this.state.orderDetails._id;
            } else if (this.state.orderDetails.test_id._id === testId) {
                reqInfo._id = this.state.orderDetails._id;
            }
            let createSubPanelsPromise = new Promise((resolve, reject) => {
                saveRequisitionChanges(reqInfo)
                    .then((response) => {
                        let orderId = response.data._id;
                        createRequisitionPDF({ orderId: orderId })
                            .then((response) => {
                                resolve(orderId);
                            })
                            .catch((error) => {
                                reject(error);
                            });
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
            let orderId = await createSubPanelsPromise;
            orderIds.push(orderId);
        }
        //create panel
        let reqInfo = this.getParamsForRequisition(
            this.state.orderDetails.patient_id._id,
            this.state.orderDetails.test_info.sample,
            testDetails,
            'panel'
        );
        reqInfo.orderIds = orderIds;
        if (this.state.orderDetails.patient_insurance_id && this.state.orderDetails.patient_insurance_id._id) {
            reqInfo.patientInsuranceId = this.state.orderDetails.patient_insurance_id._id;
        }
        if (this.state.orderDetails.test_id.is_panel) {
            reqInfo._id = this.state.orderDetails._id;
        }
        saveRequisitionChanges(reqInfo).then((response) => {
            createRequisitionPDF({ orderId: response.data._id }).then((response) => {
                boundActions.endBlockUILoading();
                this.props.handleClose();
                this.props.context.componentParent.loadGridData();
            });
        });
    };

    getParamsForRequisition = (patientId, sample, testDetails, orderType) => {
        return {
            testId: testDetails._id,
            providerFirstName: this.state.orderDetails.provider.first_name,
            providerLastName: this.state.orderDetails.provider.last_name,
            providerNPI: this.state.orderDetails.provider.npi,
            testInfoCode: testDetails.code,
            testInfoDescription: testDetails.method_name,
            specimenType: this.state.orderDetails.test_info.specimenType,
            diagnosisCode: this.state.orderDetails.diagnosis_code,
            sample: sample,
            collectedDate: this.state.orderDetails.test_info.collected,
            collectorName: this.state.orderDetails.test_info.collector_name,
            patientId: patientId,
            facilityId: this.state.orderDetails.facility_id._id,
            orderDate: this.state.orderDetails.order_date,
            facilityOrderId: sample,
            facilitySource: this.state.orderDetails.facility_id.name,
            symptoms: this.state.orderDetails.symptoms,
            orderType: orderType
        };
    };

    render() {
        return (
            <ModalStyled
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.props.show}
                onHide={this.props.handleClose}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Upgrade to Panel</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.orderDetails && (
                        <div className="row">
                            <div className="col-12 form-group">
                                <h5>Selected requisition</h5>
                                <label>
                                    {this.state.orderDetails.test_info.sample} ({this.state.orderDetails.lab_order_id} -{' '}
                                    {this.state.orderDetails.test_id.name})
                                </label>
                            </div>
                            <div className="col-12 form-group">
                                <h5>Please select panel type you want to upgrade to</h5>
                                <RadioGroup
                                    aria-label="panel"
                                    name="targetPanelId"
                                    value={this.state.targetPanelId}
                                    onChange={this.handleChange}
                                >
                                    {this.state.panelTests.map((panelTest) => {
                                        if (panelTest._id !== this.state.orderDetails.test_id._id) {
                                            return (
                                                <FormControlLabel
                                                    key={panelTest._id}
                                                    value={panelTest._id}
                                                    control={<Radio />}
                                                    label={panelTest.name}
                                                />
                                            );
                                        }
                                        return null;
                                    })}
                                </RadioGroup>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={this.handleUpgrade}>
                        Upgrade
                    </Button>
                </Modal.Footer>
            </ModalStyled>
        );
    }
}
